module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-google-recaptcha/~/core-js/library/modules/$.library.js
 ** module id = 2841
 ** module chunks = 0
 **/